import { Button } from "flowbite-react";
import { maskCNPJ, maskCPF, onlyCnpjChars } from "../../utils/masks";
import { CgSpinner } from "react-icons/cg";
import { FaCheck, FaSearch } from "react-icons/fa";
import { isValidCNPJ, isValidCPF } from "../../utils/utils";
import { IoCloseCircleOutline } from "react-icons/io5";
import {
  fieldControlBase,
  fieldControlError,
  fieldErrorText,
  fieldLabel,
} from "./inputTheme";

const QueryInput = ({ info, setInfo, isLoading, error, type = "CPF" }) => {
  const handleChange = (event) => {
    const raw = event.target.value;
    let valor;

    if (type === "CPF") {
      valor = maskCPF(raw.replace(/\D/g, ""));
    } else if (type === "CNPJ") {
      // CNPJ alfanumérico: preserva letras nas 12 primeiras posições.
      valor = maskCNPJ(raw);
    } else {
      // CPF ou CNPJ: letra ou mais de 11 caracteres ⇒ trata como CNPJ.
      const alnum = onlyCnpjChars(raw);
      if (/[A-Z]/.test(alnum) || alnum.length > 11) {
        valor = maskCNPJ(alnum);
      } else {
        valor = maskCPF(alnum);
      }
    }

    setInfo(valor);
  };

  const checkValidType = () => {
    const isCPFValid =
      type !== "CNPJ" && info.length === 14 && isValidCPF(info);
    const isCNPJValid =
      type !== "CPF" && info.length === 18 && isValidCNPJ(info);

    if (isCPFValid || isCNPJValid) {
      return true;
    }
    return false;
  };

  const checkErrorIcon = () => {
    if (type === "CPF") {
      return info.length === 14;
    } else if (type === "CNPJ") {
      return info.length === 18;
    } else {
      return info.length === 18 || info.length === 14;
    }
  };

  return (
    <div className="w-full">
      <div className="flex flex-wrap flex-row items-end gap-2 w-full">
        <div className="relative flex-1 min-w-[220px]">
          <label htmlFor="info" className={fieldLabel}>
            Documento ({type})
          </label>

          <input
            id="info"
            type="text"
            className={`${fieldControlBase} text-sm pr-10 ${
              error ? fieldControlError : ""
            }`}
            placeholder="Digite CPF ou CNPJ"
            value={info}
            maxLength={type === "CPF" ? "14" : "18"}
            onChange={handleChange}
            required
          />

          {checkValidType() ? (
            <FaCheck className="absolute right-3 top-[39px] text-emerald-500" />
          ) : (
            checkErrorIcon() && (
              <IoCloseCircleOutline className="absolute right-3 top-[39px] text-red-500" />
            )
          )}
        </div>

        <Button
          className="h-[42px] rounded-xl bg-emerald-600 px-4 text-white shadow-sm transition hover:bg-emerald-700"
          type="submit"
          processingSpinner={<CgSpinner className="h-5 w-5 animate-spin" />}
          isProcessing={isLoading}
          disabled={!checkValidType()}
        >
          <div className="flex items-center gap-2">
            <FaSearch />
            <span>{isLoading ? "Consultando..." : "Consultar"}</span>
          </div>
        </Button>
      </div>

      {error && <small className={fieldErrorText}>{type} inválido!</small>}
    </div>
  );
};

export default QueryInput;
